<template>
    <div class="popup" v-show="show">
        <div class="detail bg_white">
            <Icon class="closer cursor_pointer" type="md-close" @click="show=false" size="26"/>
            <div class="title f18 bold500 txt_black87 tc">发票详情</div>
            <div class="content content1" v-if="data.type == 0">
                <div class="item txt_black54 f14 bold500 w100">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        个人名称：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" v-model="data.personal_name" disabled/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500 w100">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        收票人手机：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" v-model="data.phone" disabled/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500 w100">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        收票人邮箱：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" v-model="data.email" disabled/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500 w100">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        金额：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" v-model="price" disabled/>
                    </div>
                </div>
            </div>
            <div class="content" v-if="data.type == 1">
                <div class="item txt_black54 f14 bold500 fl">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        单位名称：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" v-model="data.company_name" disabled/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500 fr">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        金额：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" v-model="price" disabled/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500 fl">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        收票人手机：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" v-model="data.phone" disabled/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500 fr">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        收票人邮箱：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" v-model="data.email" disabled/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500 fl">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        纳税人识别码：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" v-model="data.id" disabled/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500 fr">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        注册地址：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" v-model="data.register_address" disabled/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500 fl">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        注册电话：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" v-model="data.register_phone" disabled/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500 fr">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        开户银行：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" v-model="data.bank" disabled/>
                    </div>
                </div>
                <div class="item txt_black54 f14 bold500 fl">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        银行账号：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" v-model="data.bank_account" disabled/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<!--
-->
<script>
    export default {
        name: "detail",
        data() {
            return {
                show: false,
                price: '',
                data: {}
            }
        },
        methods: {
            init(data, price) {
                this.show = true;
                this.price = price;
                this.data = data;
            },
        }
    }
</script>

<style scoped>
    .detail {
        width: 600px;
    }
    .content{
        padding: 0 30px;
    }
    .content1 > .item {
        width: 100%;
    }
    .item {
        margin-top: 30px;
        width: 260px;
    }

    .item > div:nth-of-type(2) {
        height: 36px;
        line-height: 36px;
        margin-top: 8px;
    }

    .item > .ipt > input {
        padding: 0 10px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 3px;
    }
</style>